import './card-treatment.scss';

export default () => {
};
